import React from "react";

const BeforeLoaderDetail = () => {
  return (
    <div className="s-p-2">
      <div className="dark:s-border-black-700 s-shadow-sm s-rounded-5px s-mb-10px dark:s-opacity-85">
        <div className="s-py-4 s-px-8px s-flex s-justify-between s-items-center s-rounded-t-5px s-bg-skeleton-gradient dark:s-bg-skeleton-gradient-dark s-bg-400% s-animate-skeleton">
          <div className="s-flex s-justify-center s-items-center">
            <div className="s-w-10px s-h-10px s-mr-12px s-bg-body dark:s-bg-placeholderInFullMarket-header-dark s-rounded-full" />
            <div className="s-w-68px s-h-10px s-bg-body dark:s-bg-placeholderInFullMarket-header-dark s-rounded-50px" />
          </div>
          <div>
            <div className="s-w-10px s-h-10px s-bg-body dark:s-bg-placeholderInFullMarket-header-dark s-rounded-full" />
          </div>
        </div>
        <div className="s-border-x s-border-b s-border-black-300 dark:s-border-placeholderInFullMarket-dark s-p-8px s-bg-body s-rounded-b-5px">
          <div className="s-mb-6px">
            <div className="s-flex s-justify-between s-items-center s-mb-2px">
              <div>
                <div className="s-mb-2 s-w-219px s-h-10px s-rounded-50px s-bg-skeleton-gradient dark:s-bg-skeleton-gradient-dark s-bg-400% s-animate-skeleton" />
                <div className="s-w-90px s-h-9px s-rounded-50px s-bg-skeleton-gradient dark:s-bg-skeleton-gradient-dark s-bg-400% s-animate-skeleton" />
              </div>
              <div className="s-w-118px s-h-33px s-rounded-2px s-bg-skeleton-gradient dark:s-bg-skeleton-gradient-dark s-bg-400% s-animate-skeleton" />
            </div>
            <div className="s-flex s-justify-between s-items-center s-mb-2px">
              <div>
                <div className="s-mb-2 s-w-219px s-h-10px s-rounded-50px s-bg-skeleton-gradient dark:s-bg-skeleton-gradient-dark s-bg-400% s-animate-skeleton" />
                <div className="s-w-90px s-h-9px s-rounded-50px s-bg-skeleton-gradient dark:s-bg-skeleton-gradient-dark s-bg-400% s-animate-skeleton" />
              </div>
              <div className="s-w-118px s-h-33px s-rounded-2px s-bg-skeleton-gradient dark:s-bg-skeleton-gradient-dark s-bg-400% s-animate-skeleton" />
            </div>
          </div>
          <div className="s-flex s-justify-end s-items-center">
            <div className="s-mr-2 s-w-10px s-h-10px s-rounded-full s-bg-skeleton-gradient dark:s-bg-skeleton-gradient-dark s-bg-400% s-animate-skeleton" />
            <div className="s-w-68px s-h-10px s-rounded-50px s-bg-skeleton-gradient dark:s-bg-skeleton-gradient-dark s-bg-400% s-animate-skeleton" />
          </div>
        </div>
      </div>
      <div className="dark:s-border-black-700 s-shadow-sm s-rounded-5px s-mb-10px dark:s-opacity-85">
        <div className="s-py-4 s-px-8px s-flex s-justify-between s-items-center s-rounded-t-5px s-bg-skeleton-gradient dark:s-bg-skeleton-gradient-dark s-bg-400% s-animate-skeleton">
          <div className="s-flex s-justify-center s-items-center">
            <div className="s-w-10px s-h-10px s-mr-12px s-bg-body dark:s-bg-placeholderInFullMarket-header-dark s-rounded-full" />
            <div className="s-w-68px s-h-10px s-bg-body dark:s-bg-placeholderInFullMarket-header-dark s-rounded-50px" />
          </div>
          <div>
            <div className="s-w-10px s-h-10px s-bg-body dark:s-bg-placeholderInFullMarket-header-dark s-rounded-full" />
          </div>
        </div>
        <div className="s-border-x s-border-b s-border-black-300 dark:s-border-placeholderInFullMarket-dark s-p-8px s-bg-body s-rounded-b-5px">
          <div className="s-mb-6px">
            <div className="s-flex s-justify-between s-items-center s-mb-2px">
              <div>
                <div className="s-mb-2 s-w-219px s-h-10px s-rounded-50px s-bg-skeleton-gradient dark:s-bg-skeleton-gradient-dark s-bg-400% s-animate-skeleton" />
                <div className="s-w-90px s-h-9px s-rounded-50px s-bg-skeleton-gradient dark:s-bg-skeleton-gradient-dark s-bg-400% s-animate-skeleton" />
              </div>
              <div className="s-w-118px s-h-33px s-rounded-2px s-bg-skeleton-gradient dark:s-bg-skeleton-gradient-dark s-bg-400% s-animate-skeleton" />
            </div>
            <div className="s-flex s-justify-between s-items-center s-mb-2px">
              <div>
                <div className="s-mb-2 s-w-219px s-h-10px s-rounded-50px s-bg-skeleton-gradient dark:s-bg-skeleton-gradient-dark s-bg-400% s-animate-skeleton" />
                <div className="s-w-90px s-h-9px s-rounded-50px s-bg-skeleton-gradient dark:s-bg-skeleton-gradient-dark s-bg-400% s-animate-skeleton" />
              </div>
              <div className="s-w-118px s-h-33px s-rounded-2px s-bg-skeleton-gradient dark:s-bg-skeleton-gradient-dark s-bg-400% s-animate-skeleton" />
            </div>
          </div>
          <div className="s-flex s-justify-end s-items-center">
            <div className="s-mr-2 s-w-10px s-h-10px s-rounded-full s-bg-skeleton-gradient dark:s-bg-skeleton-gradient-dark s-bg-400% s-animate-skeleton" />
            <div className="s-w-68px s-h-10px s-rounded-50px s-bg-skeleton-gradient dark:s-bg-skeleton-gradient-dark s-bg-400% s-animate-skeleton" />
          </div>
        </div>
      </div>
      <div className="dark:s-border-black-700 s-shadow-sm s-rounded-5px s-mb-10px dark:s-opacity-85">
        <div className="s-py-4 s-px-8px s-flex s-justify-between s-items-center s-rounded-t-5px s-bg-skeleton-gradient dark:s-bg-skeleton-gradient-dark s-bg-400% s-animate-skeleton">
          <div className="s-flex s-justify-center s-items-center">
            <div className="s-w-10px s-h-10px s-mr-12px s-bg-body dark:s-bg-placeholderInFullMarket-header-dark s-rounded-full" />
            <div className="s-w-68px s-h-10px s-bg-body dark:s-bg-placeholderInFullMarket-header-dark s-rounded-50px" />
          </div>
          <div>
            <div className="s-w-10px s-h-10px s-bg-body dark:s-bg-placeholderInFullMarket-header-dark s-rounded-full" />
          </div>
        </div>
        <div className="s-border-x s-border-b s-border-black-300 dark:s-border-placeholderInFullMarket-dark s-p-8px s-bg-body s-rounded-b-5px">
          <div className="s-mb-6px">
            <div className="s-flex s-justify-between s-items-center s-mb-2px">
              <div>
                <div className="s-mb-2 s-w-219px s-h-10px s-rounded-50px s-bg-skeleton-gradient dark:s-bg-skeleton-gradient-dark s-bg-400% s-animate-skeleton" />
                <div className="s-w-90px s-h-9px s-rounded-50px s-bg-skeleton-gradient dark:s-bg-skeleton-gradient-dark s-bg-400% s-animate-skeleton" />
              </div>
              <div className="s-w-118px s-h-33px s-rounded-2px s-bg-skeleton-gradient dark:s-bg-skeleton-gradient-dark s-bg-400% s-animate-skeleton" />
            </div>
            <div className="s-flex s-justify-between s-items-center s-mb-2px">
              <div>
                <div className="s-mb-2 s-w-219px s-h-10px s-rounded-50px s-bg-skeleton-gradient dark:s-bg-skeleton-gradient-dark s-bg-400% s-animate-skeleton" />
                <div className="s-w-90px s-h-9px s-rounded-50px s-bg-skeleton-gradient dark:s-bg-skeleton-gradient-dark s-bg-400% s-animate-skeleton" />
              </div>
              <div className="s-w-118px s-h-33px s-rounded-2px s-bg-skeleton-gradient dark:s-bg-skeleton-gradient-dark s-bg-400% s-animate-skeleton" />
            </div>
          </div>
          <div className="s-flex s-justify-end s-items-center">
            <div className="s-mr-2 s-w-10px s-h-10px s-rounded-full s-bg-skeleton-gradient dark:s-bg-skeleton-gradient-dark s-bg-400% s-animate-skeleton" />
            <div className="s-w-68px s-h-10px s-rounded-50px s-bg-skeleton-gradient dark:s-bg-skeleton-gradient-dark s-bg-400% s-animate-skeleton" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default BeforeLoaderDetail;
